/**
 * @author Gananath Athukorala
 * @version 0.1
 * @since 6/23/2023
 */
import React, { useState, useEffect } from "react"
import Helpers from "../../../../base/utils/Helpers"
import DeleteModal from "../../../components/DeleteModals/DeleteModal"
import EditGroupsModal from "./EditGroupsModal"
import ApproveGrpMoreInfoModal from "./grpMoreInfo/ApproveGrpMoreInfoModal"
import QrCodeModal from "./QrCodeModal"
import { useNavigate } from "react-router-dom"
import api from "../../../../base/services/ResApi"
import { RequestErrorHandeling } from "../../../../base/errorHandeling/RequestErrorHandeling"
import ApproveCardItem from "./ApproveCardItem"
import ApkUploadModal from "../../application/components/ApkUploadModal"
import BroadcastingModal from "./BroadcastingModal"
import broadcastingInProgress from "../../../../../resources/broadcastingInProgress.gif"
import broadcastingNew from "../../../../../resources/broadcastingNew.gif"
import broadcastingCompleted from "../../../../../resources/broadcastingCompleted.gif"
import broadcastingRetry from "../../../../../resources/broadcastingRetry.gif"
import broadcastingstopped from "../../../../../resources/broadcastingstopped.gif"
import broadcastingStart from "../../../../../resources/broadcastingStart.gif"

const ApprovedGroupsItem = (props) => {
  const [deleteModalOpen, setDeleteModalopen] = useState(false)
  const [editModalOpen, setEditModalOpen] = useState(false)
  const [uploadModalOpen, setUploadModalOpen] = useState(false)
  const [qrCodeModalOpen,setQrCodeModalOpen]=useState(false)
  const [isBtnLoading, setIsBtnLoading] = useState(false)
  const [moreInfoModalOpen, setMoreInfoModalOpen] = useState(false)
  const [broadcastModalOpen, setBroadcastModalOpen] = useState(false)
  const [orgCode, setOrgCode] = useState(props.grpData.orgCode)

  // setting
  const [settingColor, setSettingColor] = useState("red")
  const [updateColor, setUpdateColor] = useState("red")
  const [broadcastIcon, setBroadcastIcon] = useState(broadcastingNew)

  // To navigate
  const navigate = useNavigate()
  const handleNavigate = (orgCode, groupId) => {
    let payload = {
      orgCode: orgCode,
      groupId: groupId,
      filterByType: "F_GRP_ID",
    }
    navigate("../../app/terminals", { state: payload })
  }

  // delete model api
  const handleDelete = () => {
    setIsBtnLoading(true)

    api
      .delete("/groups/" + props.grpData.groupId)
      .then((res) => {
        setIsBtnLoading(false)
        setEditModalOpen(false)
        props.setIsSuccess(true)
        props.setSuccessMessages([res.data?.description])
        props.setErrorMessages([])
        props.setIserror(false)
        setTimeout(() => {
          props.setUpdateData(true)
          setDeleteModalopen(false)
        }, 3000)
      })
      .catch((error) => {
        setIsBtnLoading(false)
        setEditModalOpen(false)
        props.setIsSuccess(false)
        setDeleteModalopen(false)
        RequestErrorHandeling(
          error,
          props.setIserror,
          props.setErrorMessages,
          props.setIserrorShow,
          props.setIsUnauhtError
        )
        setTimeout(() => {
          setDeleteModalopen(false)
        }, 3000)
      })
  }

  // set bg colors

  const setting = Helpers.applyRemoverWords(
    Helpers.replaceUnderscoresWithSpaces(props.grpData.settlementStng),
    "Settlement"
  )

  useEffect(() => {
    if (props.grpData.settlementStng === "AUTO_SETTLEMENT") {
      setSettingColor("#009900")
    } else if (props.grpData.settlementStng === "SKIP_SETTLEMENT") {
      setSettingColor("#000000")
    }
  }, [setting])

  const update = Helpers.applyRemoverWords(
    Helpers.replaceUnderscoresWithSpaces(props.grpData.deployStgy),
    "Update"
  )
  useEffect(() => {
    if (props.grpData.deployStgy === "SILENT_UPDATE") {
      setUpdateColor("#9494b8")
    } else if (props.grpData.deployStgy === "SCHEDULE_UPDATE") {
      setUpdateColor("#800060")
    } else if (props.grpData.deployStgy === "REGULAR_UPDATE") {
      setUpdateColor("#e68a00")
    } else if (props.grpData.deployStgy === "HOLD_UPDATE") {
      setUpdateColor("#1a8cff")
    } else if (props.grpData.deployStgy === "STOP_UPDATE") {
      setUpdateColor("#ff0000")
    }
  }, [update])

  // set broadcastIcon
  useEffect(() => {
    if (props.grpData.deployStatus === "IN_PROGRESS") {
      setBroadcastIcon(broadcastingInProgress)
    } else if (props.grpData.deployStatus === "NEW") {
      setBroadcastIcon(broadcastingNew)
    } else if (props.grpData.deployStatus === "COMPLETED") {
      setBroadcastIcon(broadcastingCompleted)
    } else if (props.grpData.deployStatus === "RETRY") {
      setBroadcastIcon(broadcastingRetry)
    } else if (props.grpData.deployStatus === "STOP") {
      setBroadcastIcon(broadcastingstopped)
    } else if (props.grpData.deployStatus === "START") {
      setBroadcastIcon(broadcastingStart)
    }
  }, [])

  return (
    <div style={{ minWidth: 0, height: "100%" }}>
      <ApproveCardItem
        groupSummaryDtl={props.grpData.groupSummaryDtl}
        orgName={props.grpData.orgName || props.approvedOrgData?.orgName}
        orgCode={props.grpData.orgCode}
        groupId={props.grpData.groupId}
        groupName={props.grpData.groupName}
        icon={props.grpData.icon}
        setDeleteModalopen={setDeleteModalopen}
        setEditModalOpen={setEditModalOpen}
        setQrCodeModalOpen={setQrCodeModalOpen}
        settlementStng={props.grpData.settlementStng}
        setting={setting}
        settingColor={settingColor}
        update={update}
        updateColor={updateColor}
        deployStatus={props.grpData.deployStatus}
        setMoreInfoModalOpen={setMoreInfoModalOpen}
        handleNavigate={handleNavigate}
        setUploadModalOpen={setUploadModalOpen}
        setBroadcastModalOpen={setBroadcastModalOpen}
        broadcastIcon={broadcastIcon}
      />
      <DeleteModal
        open={deleteModalOpen}
        onClose={() => setDeleteModalopen(false)}
        onDelete={handleDelete}
        isBtnLoading={isBtnLoading}
      />
      <BroadcastingModal
        open={broadcastModalOpen}
        onClose={() => setBroadcastModalOpen(false)}
        deployStatus={props.grpData.deployStatus}
        groupId={props.grpData.groupId}
        setUpdateData={props.setUpdateData}
      />
      <QrCodeModal
        open={qrCodeModalOpen}
        onClose={() => setQrCodeModalOpen(false)}
        orgCode={props.grpData.orgCode}
        groupId={props.grpData.groupId}
      />
      <EditGroupsModal
        open={editModalOpen}
        setUpdateData={props.setUpdateData}
        orgCode={orgCode}
        setOrgCode={setOrgCode}
        onClose={() => setEditModalOpen(false)}
        grpId={props.grpData.groupId}
        grpData={{
          groupName: props?.grpData.groupName,
          icon: props?.grpData.icon,
          settlementStng: props.grpData.settlementStng,
          deployStgy: props.grpData.deployStgy,
          scheduledUpdateOnDateTime: props.grpData.scheduledUpdateOnDateTime,
          description: props.grpData.description,
          clearAppStatus: props.grpData.clearAppStatus,
        }}
      />
      <ApkUploadModal
        open={uploadModalOpen}
        onClose={() => setUploadModalOpen(false)}
        orgName={props.grpData.orgName}
        orgCode={props.grpData.orgCode}
        grpName={props.grpData.groupName}
        grpId={props.grpData.groupId}
        defaultTab="Upload"
        fromGroup={true}
      />
      <ApproveGrpMoreInfoModal
        open={moreInfoModalOpen}
        onClose={() => setMoreInfoModalOpen(false)}
        grpData={props.grpData}
        orgLogo={props.orgLogo}
        approvedOrgData={props.approvedOrgData}
        settlementStng={props.grpData.settlementStng}
        setting={setting}
        settingColor={settingColor}
        update={update}
        updateColor={updateColor}
        deployStatus={props.grpData.deployStatus}
        groupSummaryDtl={props.grpData.groupSummaryDtl}
        latestApplications={props.grpData.latestApplications}
        latestAppDtl={props.grpData.latestApplication}
        broadcastIcon={broadcastIcon}
      />
    </div>
  )
}
export default ApprovedGroupsItem
